<template>
  <div>
    <PromptControl
      @ok="ok"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="show"
      v-bind:title="lang('lbl_0000056')"
      v-bind:message="lang('lbl_0000057')"
    />
    <ContentWrapperControl class="mt-4">
      <div class="bg-white p-4 rounded-lg shadow">
        <div class="mb-3">
          <TextControl
            @typing="typing"
            v-bind:value="date_of_birth"
            name="date_of_birth"
            type="date_of_birth"
          />
        </div>
        <div>
          <ButtonControl
            v-if="this.$store.state.info.date_of_birth == null"
            v-on:click="update"
            v-bind:disabled="disabled"
          >
            {{ lang("lbl_0000050") }}
          </ButtonControl>
          <span v-else class="mt-1 text-xs text-grey-dark italic">{{
            lang("lbl_0000259")
          }}</span>
        </div>
      </div>
      <PrivacyInfoControl />
    </ContentWrapperControl>
  </div>
</template>

<script>
import { onBeforeRouteLeave } from "vue-router";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import PromptControl from "./../../components/controls/PromptControl.vue";
import TextControl from "./../../components/controls/TextControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    TextControl,
    PrivacyInfoControl,
    PromptControl,
  },
  data() {
    return {
      theme: "error",
      display: false,
      message: null,
      changed: false,
      disabled: true,
      show: false,
      date_of_birth: null,
      href: null,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000260"),
      show: true,
      back: true,
    });

    onBeforeRouteLeave((to) => {
      this.href = to.fullPath;
      if (this.changed) {
        this.show = true;
        return false;
      }
    });

    this.date_of_birth =
      this.formatToISODate(this.$store.state.info.date_of_birth) || "";
  },
  methods: {
    typing(n) {
      this.date_of_birth = n.value;
      this.disabled =
        this.date_of_birth === "" ||
        this.date_of_birth ===
          this.formatToISODate(this.$store.state.info.date_of_birth);
    },
    update() {
      this.$emit("showloader");
      const [year, month, day] = this.date_of_birth.split("-");
      const formatted_date = `${month}/${day}/${year}`;

      User.updateDateOfBirth(this.$store.state.key, month, day, year)
        .then(() => {
          this.$store.state.info.date_of_birth = formatted_date;
          this.disabled = true;
          this.changed = false;
          this.$emit("hideloader");
          this.$emit("success", this.lang("lbl_0000261"));
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    closed() {
      this.display = false;
    },
    formatToISODate(date) {
      if (!date) return "";
      const parsed_date = new Date(date);
      if (isNaN(parsed_date)) return "";
      const year = parsed_date.getFullYear();
      const month = String(parsed_date.getMonth() + 1).padStart(2, "0");
      const day = String(parsed_date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    cancel() {
      this.show = false;
    },
    ok() {
      this.changed = false;
      this.$router.push(this.href);
    },
  },
  watch: {
    date_of_birth(val) {
      this.changed = val != this.$store.state.info.date_of_birth;
    },
  },
};
</script>
